import React from 'react';
import { Typography } from '@weave-mui/material';

/**
 * TotalSelectedBadge component displays the count of selected or available test cases
 * @param {Object} props - Component props
 * @param {number} props.available - Number of available test cases
 * @param {number} props.selected - Number of selected test cases
 * @param {number} props.total - Total number of test cases
 */
const TotalSelectedBadge = ({ available, selected, total }) => {
  if (total === 0) {
    return null;
  }

  const message = selected
    ? `Selecting ${selected} out of ${total} tests`
    : `Showing ${available} out of ${total} tests`;

  return (
    <Typography variant="body2" color="textSecondary">
      {message}
    </Typography>
  );
};

export default TotalSelectedBadge;
